<template>
  <div class="d-flex align-center column-gap-2">
    <ClosdFildersIcon :document="document" :size="20" />
    <div class="document-name column-gap-1"
         :class="{ 'clickable': isFilePdf }"
         data-locator="file-name"
         @click="onOpenDocument">
      <TruncatedText>
        {{ displayedNumbering }}{{ documentName }}
      </TruncatedText>
      <template v-if="isDocumentMultiVersions">
        <app-badge>{{ `v${document.version}` }}</app-badge>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'
import TruncatedText from '@/common/TruncatedText.vue'
import { getFileExtension, openFileViewer } from '@/common/utils/files'
import { type Filder } from '@/project/documents/types'

const props = defineProps<{
  document: Filder,
}>()

const displayedNumbering = computed(() => {
   if (!props.document?.numbering) return ''
   return `${props.document.numbering.split('.').splice(2).join('.')} `
})
const documentName = computed(() => props.document.basename || props.document.name || '')
const isDocumentMultiVersions = computed(() => (props.document?.nbVersions ?? 0) > 1)

const store = useStore()
const isFilePdf = computed(() => getFileExtension(props.document) === 'pdf')

function onOpenDocument() {
  if (!isFilePdf.value) return
  openFileViewer(store.getters['room/roomMnemo'], props.document.id)
}
</script>

<style scoped lang="scss">
.document-name {
  width: 170px;
  display: flex;
  align-items: center;
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgb(var(--v-theme-grey--900));
}
</style>
